export function MsgDeskLoading() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#eef1f4] px-6 text-[#263646]">
      <div className="rounded-lg border border-[#d4dde6] bg-white px-6 py-5 shadow-sm">
        <div className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[#637285]">Email</div>
        <div className="mt-2 text-sm">Opening message…</div>
      </div>
    </div>
  )
}
